import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { CommonServiceService } from '../../common-service.service';
import { environment } from 'src/environments/environment';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';

@Component({
  selector: 'app-unpaid-report-search',
  templateUrl: './unpaid-report-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class UnpaidReportSearchComponent implements OnInit {

  gstreportFilterForm: FormGroup;
  clientArr: any;
	@ViewChild('searchButton',{static:true}) searchButton : ElementRef;
	minDate = "2023-04-01"
  maxDate = moment().format('YYYY-MM-DD')
  keyword = 'name';
  @ViewChild('accountAC',{static:true}) accountAC;
  dateFormat = 'YYYY-MM-DD';
  isLocaleDateFormat: boolean = true;

  constructor(
    public commonService: CommonServiceService,
    private router: Router,
    private formBuilder: FormBuilder,
    private store: Store<InitialState>
    ) { 
  
      this.store.select('sharedReducers').subscribe((items)=>{
        if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
          this.minDate = items.financeYear.start_date
          this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
                      moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        } else {
          let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
          if(!current_financial_year) {
            current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
          }
          this.minDate = current_financial_year.start_date
          this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
                      moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        }
    })
  }

  ngOnInit() {

    this.gstreportFilterForm = this.formBuilder.group({
      start_date: [this.minDate, this.checkDate('start_date')],
      end_date: [this.maxDate,this.checkDate('end_date')],
      client: [''],
			client_name: [''],
      account_type: ['client'],
      subgroup_type: ['']
    })
    this.setFormData()
    this.getGlobalSettingsFormattedDate();

  }

  checkDate(formControlName){
		return (control: AbstractControl) => {
			let valid = true
			if(!moment(control.value, 'YYYY-MM-DD').isValid()) {
				valid = false
			} else {
				if(this){
					if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
						valid = false
					}
				}
			}
			return !valid ? {[formControlName]: {value: control.value}} : null;
		};
	}

  setFormData() {
    let queryParams = localStorage.getItem('activeGSTQueryParams')
    if (queryParams != null) {
      let parsedParams = JSON.parse(queryParams)
      if (parsedParams.start_date != "") {
        this.gstreportFilterForm.controls.start_date.setValue(moment(parsedParams.start_date).format('YYYY-MM-DD') )
      }
      if (parsedParams.end_date != "") {
        this.gstreportFilterForm.controls.end_date.setValue(moment(parsedParams.end_date).format('YYYY-MM-DD'))
      }
    }
  }

  search(values) {
    GlobalVariable.openModalStatus = false;
    if (values.start_date == null || values.start_date == "" || values.start_date == "Invalid Date" || values.start_date == "Invalid date") {
      values.start_date = ""
    }
    else {
      values.start_date = moment(values.start_date).format('YYYY-MM-DD')
    }
    if (values.end_date == null || values.end_date == "" || values.end_date == "Invalid Date" || values.end_date == "Invalid date") {
      values.end_date = ""
    }
    else {
      values.end_date = moment(values.end_date).format('YYYY-MM-DD')
    }
    this.router.navigateByUrl(`/report/client-unpaid-report?start_date=${values.start_date}&end_date=${values.end_date}&client=${values.client}&subgroup_type=${values.subgroup_type}`)
  }

  reset() {
    GlobalVariable.openModalStatus = false;
    this.gstreportFilterForm = this.formBuilder.group({
      start_date: [''],
      end_date: ['']
    })
    localStorage.removeItem('activeGSTQueryParams')
  }

  clickSearchButton(){
		this.searchButton.nativeElement.click()
	}

  getClient(value,bindValue = false) {
    this.gstreportFilterForm.controls['subgroup_type'].setValue("")
		if (value.length > 2) {
			let searchType = this.gstreportFilterForm.value.account_type
			this.commonService.getOkount(`${searchType}/autocomplete?name_like=${value.toUpperCase()}`).subscribe(res => {
				this.clientArr = res
				if(bindValue && this.clientArr.length>0){
					this.gstreportFilterForm.controls['client'].setValue(this.clientArr[0].account_code)
					this.gstreportFilterForm.controls['client_name'].setValue(this.clientArr[0].name)

				}
			}, err => {

			})
		}
	}

  selectAccount(value,formControlName){
		try {
			this.gstreportFilterForm.controls[formControlName].setValue(value.account_code)
		} catch (error) {

		}
	}

  focusAccountAc(){
		this.accountAC.focus();
	}
  removeClient(){
    this.gstreportFilterForm.controls['client'].setValue("")
    this.gstreportFilterForm.controls['client_name'].setValue("")
  }
  
  async getGlobalSettingsFormattedDate() {
      let globalSettingConfig = this.commonService.globalSettingConfig;
      if(!globalSettingConfig || globalSettingConfig.length == 0) {
        globalSettingConfig = await this.commonService.getGlobalSettings();
      }

      let dateConfig = await this.commonService.getDateFormat('date_format')
      this.dateFormat = dateConfig.dateFormat
      this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
  }

}

